import axios from 'axios';

const URL = '/static/json/vacancies.json';

export const careerAPI = axios.create({
  baseURL: URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});
